"use strict";

var React = require("react");

var SvgIconDot2 = function SvgIconDot2() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
    },
    /*#__PURE__*/ React.createElement("circle", {
      cx: 12.127,
      cy: 12.178,
      r: 7.153,
      fill: "currentColor",
    })
  );
};

exports["foreignIcon"] = SvgIconDot2;
